export default __webpack_public_path__ + "static/media/03_AtArmsLengthI_a.f65e0c33.jpg";